import { Component } from '@angular/core';

@Component({
  selector: 'app-search-analytics-main',
  templateUrl: './search-analytics-main.component.html',
  styleUrls: ['./search-analytics-main.component.scss']
})
export class SearchAnalyticsMainComponent {
  activeTab = 'dashboard';

  constructor() {}

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  isActiveTab(tab: string): boolean {
    return this.activeTab === tab;
  }
}
